import React, { useState } from "react";
import Select from "react-select";
import { FormFeedback, Label } from "reactstrap";

const Dropdown = (props) => {
  const {
    placeholder,
    options,
    selectedOption,
    setSelectedOption,
    valueText,
    labelText,
    error,
    focus,
    boxClass,
    className,
    classNamePrefix,
    isMulti = false,
    style,
    disabled,
    components,
    onMenuScrollToBottom,
    isClearable,
    floating,
    label,
    labelSpan,
    labelSpanClass,

  } = props;
  const invalid = !!(focus && error);
  const valid = !!(focus && !error);
  const [isFocused, setIsFocused] = useState(false);

  const select = (
    <Select
      isMulti={isMulti}
      // hideSelectedOptions={!isMulti}
      className={className}
      styles={style
      }
      value={selectedOption}
      // value={
      //   typeof selectedOption === "string"
      //     ? options?.find((item) => item[valueText] === selectedOption)
      //     : selectedOption
      // }
      classNamePrefix={classNamePrefix}
      onChange={setSelectedOption}
      options={
        valueText === "value" && labelText === "label"
          ? options
          : options?.map((item) => ({
            value: item[valueText],
            label: item[labelText],
            data: item
          }))
      }
      menuPlacement="auto"
      maxMenuHeight={190}
      placeholder={floating ? "" : placeholder}
      isDisabled={disabled}
      isClearable={isClearable}
      components={components}
      onMenuScrollToBottom={onMenuScrollToBottom}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      onMenuOpen={() => setIsFocused(true)}
      onMenuClose={() => setIsFocused(false)}
    />
  );

  if (floating) {
    const hasValue = isMulti ? Array.isArray(selectedOption) && selectedOption.length > 0 : !!selectedOption;
    const isActive = isFocused || hasValue;
    return (
      <div className={`${boxClass || ""} floating-select ${isActive ? "is-active" : ""} ${invalid ? "has-error" : ""}`}>
        {select}
        {label && (
          <Label className="floating-label">
            {label}
            <span className={labelSpanClass}>{labelSpan}</span>
          </Label>
        )}
        {invalid && <FormFeedback>{error}</FormFeedback>}
      </div>
    );
  }

  return (
    <div className={boxClass}>
      {select}
      {invalid && <FormFeedback>{error}</FormFeedback>}
    </div>
  );
};

export default Dropdown;
